import deletePackage from "@custom/rtk-apis/billing/deleteBilling";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status:"",
  result:{},
  msg:"",
  loading:false,
  error:""

};

const deletePackageSlice = createSlice({
  name: "deletePackageSlice",
  initialState,
  reducers: {
    closePatientDeleteModal (state:any) { state.status = ""; }
  },
  extraReducers: (builder) => {
    console.log("----------",builder)
    builder
      .addCase(deletePackage.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(deletePackage.fulfilled, (state, { payload }) => {
        console.log("Fulfilled",payload)
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(deletePackage.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
      });
  },
});

export default deletePackageSlice.reducer;
export const { closePatientDeleteModal } = deletePackageSlice.actions;
